<template>
  <v-app>
    <AppBar></AppBar>
    <View></View>
    <Footer></Footer>  
    <DialogStores :fechar="fecharStores" :model="modelStores"></DialogStores>
    <DialogLogin :fechar="fecharLogin" :model="modelLogin"></DialogLogin>
    <DialogAddressRegister :fechar="fecharAddress" :model="modelAddress" :address="address" :register="register"></DialogAddressRegister>
    <DialogMessage :fechar="fecharMessage" :model="modelMessage" :title="dialog.title" :message="dialog.message" :response="dialog.response"></DialogMessage>
    <DialogNPS :fechar="fecharNPS" :model="modelNPS" :order_id="order_id" :is_physical_nps="is_physical_nps"></DialogNPS>
  </v-app>
</template>

<script>
import AppBar from './AppBar.vue';
import View from './View.vue';
import Footer from './Footer.vue';
import DialogMessage from '@/components/DialogMessage.vue';
import DialogStores from '@/components/DialogStores.vue';
import DialogLogin from '@/components/DialogLogin.vue';
import DialogAddressRegister from '@/components/DialogAddressRegister.vue';
import DialogNPS from '@/components/DialogNPS.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Default',
  components: {
    AppBar,
    View,
    Footer,
    DialogStores,
    DialogLogin,
    DialogMessage,
    DialogAddressRegister,
    DialogNPS,
  },
  data(){
    return {
      modelMessage: false,
      modelStores: false,
      modelLogin: false,
      modelAddress: false,
      modelNPS: false,
      order_id: null,
      is_physical_nps: 0,
      address: null,
      register: null,
      dialog: {
        title: "",
        message: "",
        response: null,
        fechar: null
      },
      cartInterval: null,
      liveInterval: null
    }
  },
  computed: {
    ...mapState('cart', {
      modifiedShoppingCart: 'modifiedShoppingCart'
    }),
  },
  watch: {
    modifiedShoppingCart(v){
      if(v == 1){
        this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Houve algumas alterações nos produtos e seu carrinho foi atualizado com sucesso! =)" });
        this.clearModifiedShoppingCart();
      }
    }
  },
  methods: {
    ...mapActions('main', {
      live: 'live',
      clearNPS: 'clearNPS'
    }),
    ...mapActions('cart', {
      sendCart: 'sendCart',
      clearModifiedShoppingCart: 'clearModifiedShoppingCart'
    }),
    fecharMessage: function(){
      this.modelMessage = false;
      this.dialog.title = "";
      this.dialog.message = "";
      this.dialog.response = null;
      if(this.dialog.fechar != null){
        this.dialog.fechar();
      }
      this.dialog.fechar = null;
    },
    fecharLogin: function(){
      this.modelLogin = false;
    },
    fecharStores: function(){
      this.modelStores = false;
    },
    fecharAddress: function(){
      this.modelAddress = false;
    },
    fecharNPS: function(){
      this.modelNPS = false;
    },
    timeSendCart(){
      if(this.cartInterval){
        clearInterval(this.cartInterval);
      }
      this.cartInterval = setInterval(() => {
        this.sendCartWs();
      }, 3000);
    },
    sendCartWs(){
      this.sendCart().then(function(response){
        if(response){
          if(response.itensAddAnalytics.length > 0)
            this.emitter.emit("sendAnalyticsEvent", { event: "add_to_cart", parameters: { currency : "BRL", value: response.valueAddAnalytics, items: response.itensAddAnalytics } } );
          if(response.itensRemoveAnalytics.length > 0)
            this.emitter.emit("sendAnalyticsEvent", { event: "remove_from_cart", parameters: { currency : "BRL", value: response.valueRemoveAnalytics, items: response.itensRemoveAnalytics } } );
          clearInterval(this.cartInterval);
        }
      }.bind(this));
    }
  },
  mounted(){
    this.emitter.on('dialogMessage', function({ title = '', message = '', fechar = null, response = null}){
      this.dialog.title = title;
      this.dialog.message = message;
      this.dialog.response = response;
      this.dialog.fechar = fechar; 
      this.modelMessage = true;
    }.bind(this));
    this.emitter.on('dialogLogin', function(){
      this.modelLogin = true;
    }.bind(this));
    this.emitter.on('dialogStores', function(){
      this.modelStores = true;
    }.bind(this));
    this.emitter.on('dialogAddress', function({ address = null, register = null }){
      this.register = register;
      this.address = address;
      this.modelAddress = true;
    }.bind(this));
    this.emitter.on('dialogNPS', function({ order_id = null, is_physical_nps = 0 }){
      this.order_id = order_id;
      this.is_physical_nps = is_physical_nps;
      this.modelNPS = true;
      this.clearNPS();
    }.bind(this));
    this.emitter.on('sendCart', function(){
      this.timeSendCart();
    }.bind(this));
    this.liveInterval = setInterval(() => {
      this.live();
    }, 20000);
  },
  created() {
    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });
  },
  unmounted(){
    this.emitter.off('sendCart');
    clearInterval(this.liveInterval);
  }
}
</script>